export default "__VITE_ASSET__DMnvVpiw__"